import React from "react";
import {Row, RowProps} from "./grid";

const PageSectionRow : React.FC<RowProps> = ({children, className, ...props}) =>
    <Row className={(className||"")+" mt-32"} {...props}>
        {children}
    </Row>

export default PageSectionRow;